import TalentListPage from '../components/Talent/TalentListPage'

const Candidates = () => {
  return (
    <>
      <title>Candidates | Talent Service</title>
      <TalentListPage talentType="candidate" />
    </>
  )
}

export default Candidates
